export var GAP_CURSOR_POSITION = /*#__PURE__*/function (GAP_CURSOR_POSITION) {
  GAP_CURSOR_POSITION["LEFT"] = "left";
  GAP_CURSOR_POSITION["RIGHT"] = "right";
  return GAP_CURSOR_POSITION;
}({});
export var TARGET_SELECTION_SOURCE = /*#__PURE__*/function (TARGET_SELECTION_SOURCE) {
  TARGET_SELECTION_SOURCE["CURRENT_SELECTION"] = "currentSelection";
  TARGET_SELECTION_SOURCE["HTML_ELEMENT"] = "htmlElement";
  return TARGET_SELECTION_SOURCE;
}({});

// Not a discriminated union because we are using `selection.toJSON()`